export default __webpack_public_path__ + "static/media/personality-test-blue.46dc6e4a.png";